import { RoutesMounter } from '../../types';
import SubcontractorBillsIndex from './pages/SubcontractorBillsIndex';

export const mountSubcontractorBillsRoutes: RoutesMounter = ({ path }) => [
  {
    path,
    children: [{ index: true, element: <SubcontractorBillsIndex /> }],
  },
];
